import PropTypes from 'prop-types';

const ChartAxis = ({ ticks, title, tickTemplate = label => label }) => (
  <div className="pt-4 border-t border-gray-200/30">
    <div className="relative text-xs text-gray-500 mb-2 h-5">
      {ticks.map((tick, index) => (
        <span
          key={index}
          className={`absolute transform ${index === ticks.length - 1 ? '-translate-x-full' : '-translate-x-1/2'} ${tick.isZero ? 'font-medium text-gray-700' : ''}`}
          style={{ left: `${tick.position}%` }}
        >
          {tickTemplate(tick.label)}
        </span>
      ))}
    </div>
    <div className="text-center text-sm font-medium text-gray-700">{title}</div>
  </div>
);

ChartAxis.propTypes = {
  ticks: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  unitString: PropTypes.string.isRequired,
  tickTemplate: PropTypes.func,
};

export default ChartAxis;
